import React from "react";
import PropTypes from "prop-types";
import { NotebookImage } from "@learningblocks/shared-components";

/**
 * QuestionImage.
 *     -Image to Display in Question
 */
export function QuestionImage(props) {
  return (
    <NotebookImage
      image={props.image}
      altText={props.altText}
      className={props.className}
      preview={props.preview}
    />
  );
}

QuestionImage.propTypes = {
  /**
   * URL/{src:URL,caption:text} Content for image
   */
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      /**
       * Image URL
       */
      src: PropTypes.string,
      /**
       * Caption for Image
       */
      caption: PropTypes.string,
    }),
  ]),
  /**
   * className to set on component
   */
  className: PropTypes.string,
  preview: PropTypes.bool,
};

QuestionImage.defaultProps = {
  image: "",
  className: "",
  preview: false,
};
